import React from 'react';
import { isIOS, isAndroid } from 'react-device-detect';
import { useLocation } from 'react-router';
import Links from 'models/Links';
import AppStoreBadge from 'components/banner/AppStoreBadge';
import PlayStoreBadge from 'components/banner/PlayStoreBadge';
import Locale, { DisplayLanguages } from 'localization/Localization';
import { LanguageCode } from 'localization/Localization';
import queryString from 'query-string';
import { changeLocale } from 'components/contexts/LocalizationContext';
import LegalNotices from 'components/banner/LegalNotices';


const AppDownload = () => {
	const location = useLocation();

	React.useEffect(() => {
		if (isIOS) {
			window.location.replace(Links.AppStore)
		}

		if (isAndroid) {
			window.location.replace(Links.PlayStore)
		}
	}, []);


	let lang: LanguageCode = 'en';
	const params = queryString.parse(location.search)

	if (params.lang !== undefined) {
		if (DisplayLanguages[params.lang] !== undefined) {
			lang = params.lang as LanguageCode;
			changeLocale(lang);
		}
	}

	return (
		<div className='app-downloads-page'>
			<div className='app-downloads'>
				<p className='app-downloads-text'>
					{Locale.get('app_download_text')}
				</p>
				<AppStoreBadge />
				<PlayStoreBadge />
			</div>
			<LegalNotices />
		</div>
	)
}

export default AppDownload;